<template>
  <a-modal v-bind:open="computedShowModal"
  width="800px"
  :closable="true"
  :footer="null"
  :mask-closable="false"
  :mask-style="{backdropFilter: 'blur(2px)'}"
  :keyboard="false"
  title="계정별 권한 관리"
  :centered="true"
  @cancel="uiHandler.closeModal"
  >
    <div class="modal-content-body">
      <draggable 
        class="card-body" 
        ghost-class="drag-ghost"
        :list="categories"
        :options="{
          handle: '.drag-btn'
        }"
        item-key="id"
      >
        <div v-for="(categoryItem, categoryIndex) in categories" class="category-container" :key="categoryItem._id">
          {{  categoryItem._id }}
          <div class="category-header">
            <div class="header-left">
              <section class="drag-btn">
                <i class="fa-solid fa-grip-vertical"/>
              </section>
              <h4>{{ categoryItem.name }}</h4>
            </div>
          </div>
          <draggable 
            class="menu-container" 
            ghost-class="drag-ghost"
            :list="categoryItem.menu"
            item-key="id"
            :options="{
              handle: '.drag-btn'
            }"
          >
            <div 
              class="col-sm-12 inputDiv mb-0 menu-wrapper"
              v-for="(menuItem, menuIndex) in categoryItem.menu"  
              :list="categoryItem.menu"
              :key="menuItem.menuId"
            >
              <div class="menu-wrap">
                <div class="menu-header">
                  <div class="menu-header-left">
                    <section class="drag-btn">
                      <i class="fa-solid fa-grip-vertical"/>
                    </section>
                    <h4>{{ menuItem.menuName }}</h4>
                  </div>
                  <div class="radio-container">
                    <div class="check-label" v-if="menuItem.readOptions">
                      <select v-model="menuItem.selectedOption" @change="uiHandler.test">
                        <option v-for="option in menuItem.readOptions" :value="option" :key="option.key">
                          {{ option.key }}
                        </option>
                      </select>
                      <!-- {{ JSON.stringify(menuItem.readOptions) }} -->
                    </div>
                    <div class="check-label" v-else>
                      <input 
                        type="checkbox" 
                        :id="`read-${categoryIndex}-${menuIndex}`" 
                        v-model="menuItem.read"
                      />
                      <label :for="`read-${categoryIndex}-${menuIndex}`">읽기(메뉴 노출)</label>
                    </div>
                    <div class="check-label">
                      <input 
                        type="checkbox" 
                        :id="`write-${categoryIndex}-${menuIndex}`" 
                        v-model="menuItem.write"
                      />
                      <label :for="`write-${categoryIndex}-${menuIndex}`">쓰기</label>
                    </div>
                    <div class="check-label">
                      <input 
                        type="checkbox" 
                        :id="`update-${categoryIndex}-${menuIndex}`" 
                        v-model="menuItem.update"
                      />
                      <label :for="`update-${categoryIndex}-${menuIndex}`">수정</label>
                    </div>
                    <div class="check-label">
                      <input 
                        type="checkbox" 
                        :id="`delete-${categoryIndex}-${menuIndex}`" 
                        v-model="menuItem.delete"
                      />
                      <label :for="`delete-${categoryIndex}-${menuIndex}`">삭제</label>
                    </div>
                    <div class="check-label">
                      <input 
                        type="checkbox" 
                        :id="`excel-${categoryIndex}-${menuIndex}`" 
                        v-model="menuItem.excel"
                      />
                        <label :for="`excel-${categoryIndex}-${menuIndex}`">엑셀 다운로드</label>
                    </div>
                  </div>
                </div>
                <button 
                  class="menu-remove-btn"
                  @click="uiHandler.removeMenu(categoryIndex, menuIndex)"  
                >
                  <i class="fa-solid fa-xmark" />
                </button>
              </div>

            </div>
            <button 
              type="button" 
              class="add-product-btn"
              @click="uiHandler.openMenuModal(categoryIndex)"
              v-if="categoryItem.shouldShowAddMenuBtn"
            >
              <i class="fa-solid fa-plus"/> 메뉴 추가하기
            </button>
          </draggable>
          <button 
              type="button" 
              class="category-remove-btn"
              @click="uiHandler.removeCategory(categoryIndex)"
            >
              <i class="fa-solid fa-x"/>
            </button>
        </div>
      </draggable>
    </div>
    <div 
      class="menu-manage-modal-footer"
    >
      <button 
        type="button" 
        class="add-product-btn"
        @click="uiHandler.openCategoryModal"
      >
        <i class="fa-solid fa-plus"/> 카테고리 추가하기
      </button>
    </div>
    <div class="menu-manage-modal-footer">
      <button
      type="button"
      class="certi-btn-regular btn-hover certi-gray-btn"
      @click="uiHandler.closeModal"
    >
      <p>취소</p>
    </button>
      <button
        type="button"
        class="certi-btn-regular btn-hover certi-yellow-btn"
        @click="uiHandler.updatePrivilegeInfo"
      >
        <p>권한 저장</p>
      </button>
    </div>
  </a-modal>
  <a-modal v-model:open="subModalOpen"
    width="400px"
    :closable="true"
    :footer="null"
    :mask-closable="false"
    :mask-style="{backdropFilter: 'blur(2px)'}"
    :keyboard="false"
    :title="computedTitle"
    :centered="true"
    @cancel="uiHandler.closeSubModal"
  >
    <div class="modal-content-body filtered-items">
      <div 
        class="menu-checkboxes"
        v-if="modalData.targetModalData === TargetModalDataEnum.CATEGORY"
      >
        <div 
          class="checkbox-wrap"
          v-for="(item, index) in modalData.filteredCategories"
          :key="item+index"
        >
          <input 
            type="checkbox"
            :id="item+index"
            v-model="modalData.selectedCategories"
            :value="item"
          />
          <label :for="item+index">{{ item }}</label>
        </div>
      </div>
      <div 
        class="menu-checkboxes"
        v-else  
      >
        <div 
          class="checkbox-wrap"
          v-for="(item, index) in modalData.filteredMenus"
          :key="item+index"
        >
          <input 
            type="checkbox"
            :id="item.name+index"
            v-model="modalData.selectedMenu"
            :value="item"
          />
          <label :for="item.name+index">{{ item.name }}</label>
        </div>
      </div>
    </div>
    <div class="menu-manage-modal-footer">
      <button
      type="button"
      class="certi-btn-regular btn-hover certi-gray-btn"
      @click="uiHandler.closeSubModal"
    >
      <p>취소</p>
    </button>
      <button
        type="button"
        class="certi-btn-regular btn-hover certi-yellow-btn"
        @click="uiHandler.processAdd"
      >
        <p>추가</p>
      </button>
    </div>
  </a-modal>
</template>
  
<script>
import { VueDraggableNext } from 'vue-draggable-next'
import {
  YnEnum,
} from '@/enums/common.enums';
import {
  oneBtnDialog,
  convertYnToBool,
  boolToYn,
  deepCopy,
} from '@/utils/utils';


const TargetModalDataEnum = {
  CATEGORY: 'CATEGORY', // 새 메뉴/카테고리 모달 띄울 때 분류
  MENU: 'MENU',
  INIT: '', // 최초 실행 시에는 빈값
}

export default {
  name: 'MenuManageModal',
  components: {
    draggable: VueDraggableNext,
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    username: {
      type: String,
      required: true,
      default: 'dentium',
    },
  },
  computed: {
    computedShowModal() {
      return this.showModal;
    },
    computedTitle() {
      return this.modalData.targetModalData === TargetModalDataEnum.CATEGORY
      ? '카테고리 추가' : '메뉴 추가';
    },
  },
  emits: ['closeModal'],
  data() {
    return {
      categories: [],
      uiHandler: this.ui(),
      apiHandler: this.api(),
      YnEnum,
      subModalOpen: false,
      
      TargetModalDataEnum,
      modalData: {
        wholeMenuData: [], // 메뉴 전체 데이터
        targetModalData: TargetModalDataEnum.INIT, // 서브모달에 카테고리 띄울지, 메뉴를 띄울지
        filteredCategories: [], // 모달에서 띄워줄 기선택된 항목 제외한 카테고리 배열
        filteredMenus: [], // 모달에서 띄워줄 기선택된 항목 제외한 메뉴 배열
        selectedMenu: [], // 모달에서 선택한 메뉴(v-model)
        selectedCategoryArrayIndex: 0, // 메뉴 추가 했을 때 이벤트가 발생한 카테고리의 배열 인덱스
        selectedCategories: [], // 모달에서 선택한 카테고리(v-model)
      },
    };
  },

  async mounted() {
    await this.uiHandler.getMenuList();
  },
  watch: {
    showModal(newValue, oldValue) {
      if(newValue) this.uiHandler.getPrivilegeInfo();
    }
  },
  methods: {
    ui() {
      return {
        /*
        
        카테고리 선택 모달창 on

        메뉴데이터 전체에서 카테고리명 뽑아서 중복 제거
        filteredCategories

        */
        openCategoryModal: ()=> {
          const categories = Array.from(new Set(this.modalData.wholeMenuData.map(item => item.category)));

          this.modalData.filteredCategories = categories.filter(uniqueCategory => 
            !this.categories.some(category => category.name === uniqueCategory));

          this.subModalOpen = true;
          this.modalData.targetModalData = TargetModalDataEnum.CATEGORY;
        },
        /*
        
        메뉴 선택 모달창 on

        선택한 카테고리 명 추출한 뒤 전체 메뉴 데이터에서 카테고리 명 일치하는 것만 추출
        다만 해당 카테고리에 기등록 되어 있는 메뉴는 제외
        filteredMenus에 담음
        그리고 배열의 몇 번째 카테고리인지 추출하여 저장(해당 카테고리에 메뉴를 추가해야 하기 때문)

        */
        openMenuModal: (index)=> {
          const targetCategory = this.categories[index];
          const categoryName = targetCategory.name;
          const array = deepCopy(this.modalData.wholeMenuData.filter(item => item.category === categoryName));
          const targetMenuNames = deepCopy(targetCategory.menu).map(menuItem => menuItem.menuName);
          const filteredArray = array.filter(item => 
            !targetMenuNames.includes(item.name)
          );
          this.modalData.filteredMenus = filteredArray;
          this.subModalOpen = true;
          this.modalData.selectedCategoryArrayIndex = index;
          this.modalData.targetModalData = TargetModalDataEnum.MENU;
        },
        /*
        
        카테고리/메뉴 추가(카테고리 모달이면 카테고리 추가, 메뉴 모달이면 메뉴 추가)

        */
        processAdd: async () => {
          if(this.modalData.targetModalData === TargetModalDataEnum.CATEGORY) {
            if(this.modalData.selectedCategories.length === 0) {
              await oneBtnDialog('카테고리 미선택', '카테고리를 선택해 주세요.', false);
              return;
            }
            this.uiHandler.addCategory();
            return;
          }
          if(this.modalData.targetModalData === TargetModalDataEnum.MENU) {
            this.uiHandler.addMenu();
            return;
          }
        },
        /*
        
        카테고리 추가 로직
        submit 할 때의 카테고리 데이터셋과 똑같은 구조의 object 생성
        단, 더 추가할 메뉴가 없는 경우 메뉴 추가 버튼이 있으면 안되기 때문에 
        shouldShowAddMenuBtn 불리언값도 추가(기본: 버튼 노출)

        선택한 카테고리가 selectedCategories에 없으면 categories에 넣고 filtererdCategories에서 제거

        */
        addCategory: () => {
          const obj = {
            name: this.modalData.selectedCategories,
            menu: [],
            shouldShowAddMenuBtn: true,
          }

          for(let i = this.modalData.filteredCategories.length - 1; i >=0; i --) {
            const item = this.modalData.filteredCategories[i];
            if(this.modalData.selectedCategories.indexOf(item) !== -1) {
              const obj = {
                name: item,
                menu: [],
                shouldShowAddMenuBtn: true,
              }
              this.categories.push(obj);

              this.modalData.filteredCategories.splice(i, 1);
            }
          }
        
          this.subModalOpen = false;
          this.modalData.selectedCategories = [];
        },
        /*

        메뉴 추가 로직
        
        우선 카테고리 이름이 null이거나 undefined인 경우 return

        computeMenuObject메소드를 통해 /menus/list 에 맞는 데이터포맷으로 변환(UI에 그려주기 위해)

        선택한 카테고리에 선택한 메뉴들 추가

        그리고 filteredMenus에서 해당 메뉴들 제거

        더이상 선택할 메뉴가 없다면 shouldShowAddMenuBtn 불리언 false로

        */
        addMenu: async () => {
          const targetCategory = this.categories[this.modalData.selectedCategoryArrayIndex];
          const categoryName = targetCategory.name;
          if(typeof categoryName === 'undefined' || categoryName === null) return;

          if(this.modalData.selectedMenu.length === 0) {
            await oneBtnDialog('메뉴 미선택', '노출할 메뉴를 최소 한 개 이상 선택해 주세요.', false);
            return;
          }
          const selectedMenu = deepCopy(this.modalData.selectedMenu).map(item => this.uiHandler.computeMenuObject(item));
          console.log(selectedMenu)
          targetCategory.menu.push(...selectedMenu);
          for(let i = this.modalData.filteredMenus.length - 1; i >= 0; i --) {
            const item = this.modalData.filteredMenus[i];
            for(let j = 0; j < targetCategory.menu.length; j ++) {
              if(item.name === targetCategory.menu[j].menuName) {
                this.modalData.filteredMenus.splice(i, 1);
              } 
              targetCategory.menu[j].shouldShowAddMenuBtn = true;
            }
          }
          if(this.modalData.filteredMenus.length === 0) targetCategory.shouldShowAddMenuBtn = false;
          this.subModalOpen = false;
          this.modalData.selectedMenu = [];
        },
         /*

        카테고리 선택한거 삭제

        */
        removeCategory: (categoryIndex) => {
          this.categories.splice(categoryIndex, 1);
        },
        /*

        메뉴 제거

        선택한 카테고리와 원천데이터의 메뉴 갯수 비교하여 메뉴 추가 버튼 노출/숨김

        */
        removeMenu: (categoryIndex, menuIndex) => {
          this.categories[categoryIndex].menu.splice(menuIndex, 1);

          const data = this.modalData.wholeMenuData.filter(item => item.category === this.categories[categoryIndex].name);
          if(data.length <= this.categories[categoryIndex].menu.length - 1) {
            this.categories[categoryIndex].shouldShowAddMenuBtn = false;
          } else {
            this.categories[categoryIndex].shouldShowAddMenuBtn = true;
          }
        },
        /*

        권한관리 모달 close

        targetModalData 값 초기화 하고
        subModal 값도 초기화

        */
        closeModal: () => {
          this.uiHandler.closeSubModal();
          this.targetModalData = TargetModalDataEnum.INIT;
          this.$emit('closeModal', false);
        },
        /*

        subModal close

        */
        closeSubModal: () => {
          this.subModalOpen = false;
          if(this.modalData.targetModalData ===TargetModalDataEnum.CATEGORY) {
            this.modalData.selectedCategories = [];
            this.modalData.filteredCategories = [];
            return;
          }
          if(this.modalData.targetModalData ===TargetModalDataEnum.MENU) {
            this.modalData.selectedMenu = [];
            this.modalData.filteredMenus = [];
            return;
          }
        },
        /*

        메뉴 전체 가져오기

        */
        getMenuList: async () => {
          const result = await this.apiHandler.getMenuList();
          if(result.data) this.modalData.wholeMenuData = result.data.docs;
        },
        /*

        해당 유저의 권한 가져오기
        
        username이 없는 경우, response가 아예 없는 경우 자름(비정상케이스)
        categories가 없으면 그냥 빈배열로 함수 리턴(정상케이스이나 이후 처리 불필요)
        categories배열에 값이 있는 경우
        Yn을 boolean 값으로 변환

        각 카테고리별로 총 메뉴 갯수에서 이미 등록된 메뉴 갯수를 제하여 0보다 크면 메뉴 추가 버튼 노출

        */
       test: (e) => {
        console.log(e)
       },
        getPrivilegeInfo: async () => {
          if(!this.username) return;
          const result = await this.apiHandler.getPrivilegeInfo(this.username);
          if(!result) return;
          if(!result.data.categories) {
            this.categories = [];
            return;
          }
          const newArray = result.data.categories;
          newArray.forEach(item => {
            item.menu.forEach(menu => {
              menu.isNewWindow = convertYnToBool(menu.isNewWindow);
              if(!menu.readOptions) {
                menu.read = convertYnToBool(menu.read);
              } else {
                menu.read = 'M';
                const selectedItem = menu.readOptions.find(option => option.value === YnEnum.Y);
                menu.selectedOption = selectedItem;
              }
              menu.write = convertYnToBool(menu.write);
              menu.update = convertYnToBool(menu.update);
              menu.delete = convertYnToBool(menu.delete);
              menu.excel = convertYnToBool(menu.excel);
            })
        
            const categoryName = item.name;
            const array = deepCopy(this.modalData.wholeMenuData.filter(menuItem => menuItem.category === categoryName));
            const targetMenuNames = deepCopy(item.menu).map(menuItem => menuItem.menuName);
            const filteredArray = array.filter(menuItem => !targetMenuNames.includes(menuItem.name));

            item.shouldShowAddMenuBtn = filteredArray.length > 0;
          });

 
          this.categories = newArray;
        },
        /*

        /privileges로 가져온 데이터의 menu 항목을 /menu/list의 menu 항목 데이터셋에 맞도록 변경

        */
        computeMenuObject: (rawObj) => {
          console.log(rawObj)
          const obj = {};
          obj.menuId = rawObj._id;
          obj.category = rawObj.category;
          obj.menuName = rawObj.name;
          obj.link = rawObj.link;
          obj.iconDefaultUrl = rawObj.iconDefaultUrl;
          obj.iconActiveUrl = rawObj.iconActiveUrl;
          obj.isNewWindow = rawObj.isNewWindow === YnEnum.Y ? true : false;
          if(rawObj.readOptions) {
            obj.read = 'M';
            obj.readOptions = rawObj.readOptions;
            obj.selectedOption = rawObj.readOptions.find(item => item.value === YnEnum.Y);
          } else {
            obj.read = true;
          }
       
          obj.write = true;
          obj.update = true;
          obj.delete = true;
          obj.excel = true;
          return obj;
        },
        /*

        권한 수정 전 validation

        */
        validateData: async () => {
          const lengthCheck = this.categories.some(item => item.menu.length === 0);
          if(this.categories.length === 0) {
            await oneBtnDialog('카테고리 미선택', '최소 한 개의 카테고리를 선택해 주세요.', false);
            return false;
          }
          if(lengthCheck) {
            await oneBtnDialog('메뉴 미선택', '카테고리당 최소 한 개의 메뉴를 선택해 주세요.', false);
            return false;
          }

          return true;
        },
        /*

        권한 정보 수정

        boolean에서 다시 Yn값으로 변경 후 categories 안에 담아 보냄

        readOptions가 있는 경우에(전자계약)는
        read의 값을 M으로 변경
        selectedOption의 키값을 Y로, 나머지는 N으로 변경
        이후 seelctedOption 값 자체를 제거

        */
        updatePrivilegeInfo: async () => {
          if(!await this.uiHandler.validateData()) return;
          
          const newArray = this.categories.map(category => ({
            ...category,
            menu: category.menu.map(menu => {
              const modifiedReadOptions = menu.readOptions && menu.selectedOption ? menu.readOptions.map(option => ({
                ...option,
                value: option.key === menu.selectedOption.key ? YnEnum.Y : YnEnum.N
              })) : menu.readOptions;

              const { selectedOption, ...newMenuWithoutSelectedOption } = menu;

              return {
                ...newMenuWithoutSelectedOption,
                isNewWindow: boolToYn(menu.isNewWindow),
                read: menu.readOptions ? 'M' : boolToYn(menu.read),
                write: boolToYn(menu.write),
                update: boolToYn(menu.update),
                delete: boolToYn(menu.delete),
                excel: boolToYn(menu.excel),
                ...(modifiedReadOptions && { readOptions: modifiedReadOptions })
              };
            })
          }));

          const obj = {};
          obj.username = this.username;
          obj.categories = newArray;
          const result = await this.apiHandler.updatePrivilegeInfo(obj);
          if(result.status !== 200 && result.status !== 201) return;
          await oneBtnDialog('권한 수정 완료', '권한 수정이 완료되었습니다.', true);
          this.uiHandler.closeModal();
        }
      }
    },
    api() {
      return {
        getMenuList: async () => {
          try {
            const obj = {};
            obj.page = 1;
            obj.limit = 100;
            const response = await this.$apiInstance.post(`/menus/list`, obj);
            if (response.status !== 200 && response.status !== 201) return;
            return response;

          } catch (error) {
            console.log(error);
            await oneBtnDialog('메뉴 로드 실패', '메뉴 로드에 실패하였습니다.', false);
          }
        },
        getPrivilegeInfo: async (username) => {
          try {
            if(!username) throw new Error('필수 파라미터 \'username\' 누락');
            const response = await this.$apiInstance.get(`/privileges/${username}`);
            if (response.status !== 200 && response.status !== 201) return;
            return response;

          } catch (error) {
            console.log(error);
            await oneBtnDialog('메뉴 로드 실패', '메뉴 로드에 실패하였습니다.', false);
          }
        },
        updatePrivilegeInfo: async (obj) => {
          try {
            if(!obj) throw new Error('body 객체 없음');
            const response = await this.$apiInstance.post(`/privileges`, obj);
            if (response.status !== 200 && response.status !== 201) return;
            return response;

          } catch (error) {
            console.log(error);
            await oneBtnDialog('권한 수정 실패', '권한 수정에 실패하였습니다.', false);
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/menu-manage-modal.scss';



@media screen and (max-width:767px) {
  .row{
    padding: 14px 14px 36px 14px !important
  }
  .hospital-div-wrap .div905 .black-btn{
    width: auto;
    padding: 10px 5px;
  }
  .hospital-div-wrap .button-box{
    margin-left: 0;
  }
  .certi-btn-regular{
    padding: 6.5px 9px;
  }
  .w-35{
    width: 100% !important;
  }
  .hospital-div-wrap .black-btn{
    width: 100px !important;
    padding: 8px 12px;
  }
  .hospital-div-wrap .password-area button{
    top: 43px;
  }
  .item-btn-area{
    max-width: none;
  }
  p{
    margin-bottom: 0;
  }
}
@media screen and (min-width:768px) and (max-width:1023px){
  .w-35 {
    width: 50% !important;
  }
  p{
    margin-bottom: 0;
  }
}
</style>